export const mockTransFunc = (arg: string) => arg

export const EnvelopeMarkFont = {
  ARIAL: 'Arial',
  HELVETICA: 'Helvetica',
  TIMES: 'Times New Roman'
}

export const EnvelopeMarkFontType = {
  BOLD: mockTransFunc('envelope:fontType.bold'),
  ITALIC: mockTransFunc('envelope:fontType.italic'),
  REGULAR: mockTransFunc('envelope:fontType.regular')
}

export const EnvelopeMarkType = {
  CHECKBOX: mockTransFunc('envelope:markType.checkbox'),
  CUSTOM: mockTransFunc('envelope:markType.custom'),
  FULLNAME: mockTransFunc('envelope:markType.fullname'),
  INITIALS: mockTransFunc('envelope:markType.initials'),
  POSITION: mockTransFunc('envelope:markType.position'),
  SELECT: mockTransFunc('envelope:markType.select'),
  SIGNATURE: mockTransFunc('envelope:markType.signature'),
  STRING: mockTransFunc('envelope:markType.string'),
  TEXT: mockTransFunc('envelope:markType.text')
}

export const EnvelopeRecipientParam = {
  directUserAssignment: mockTransFunc('envelope:recipientParam.directUserAssignment'),
  host: mockTransFunc('envelope:recipientParam.host'),
  initials: mockTransFunc('envelope:recipientParam.initials'),
  position: mockTransFunc('envelope:recipientParam.position'),
  resolveRecipientRule: mockTransFunc('envelope:recipientParam.resolveRecipientRule'),
  selfie: mockTransFunc('envelope:recipientParam.selfie'),
  signature: mockTransFunc('envelope:recipientParam.signature'),
  sms: mockTransFunc('envelope:recipientParam.sms'),
  stageLabel: mockTransFunc('envelope:recipientParam.stageLabel')
}

export const EnvelopeRecipientType = {
  APPROVAL: mockTransFunc('envelope:recipientType.approval'),
  ACQUAINTANCE: mockTransFunc('envelope:recipientType.acquaintance'),
  SIGNING: mockTransFunc('envelope:recipientType.signing'),
}

export const Language = {
  en: mockTransFunc('language:en'),
  pt: mockTransFunc('language:pt'),
  ru: mockTransFunc('language:ru'),
  vi: mockTransFunc('language:vi')
}

export const LanguageShort = {
  en: mockTransFunc('language:short.en'),
  pt: mockTransFunc('language:short.pt'),
  ru: mockTransFunc('language:short.ru'),
  vi: mockTransFunc('language:short.vi')
}

export const Warning = {
  email: mockTransFunc('common:warning.email'),
  inn: mockTransFunc('common:warning.inn'),
  orgName: mockTransFunc('common:warning.orgName'),
  desc: mockTransFunc('common:warning.desc'),
  guid: mockTransFunc('common:warning.guid'),
  max: {
    12: mockTransFunc('common:warning.max.12'),
    16: mockTransFunc('common:warning.max.16'),
    19: mockTransFunc('common:warning.max.19'),
    20: mockTransFunc('common:warning.max.20'),
    25: mockTransFunc('common:warning.max.25'),
    26: mockTransFunc('common:warning.max.26'),
    30: mockTransFunc('common:warning.max.30'),
    32: mockTransFunc('common:warning.max.32'),
    40: mockTransFunc('common:warning.max.40'),
    50: mockTransFunc('common:warning.max.50'),
    60: mockTransFunc('common:warning.max.60'),
    100: mockTransFunc('common:warning.max.100'),
    120: mockTransFunc('common:warning.max.120'),
    128: mockTransFunc('common:warning.max.128'),
    150: mockTransFunc('common:warning.max.150'),
    250: mockTransFunc('common:warning.max.250'),
    255: mockTransFunc('common:warning.max.255'),
    500: mockTransFunc('common:warning.max.500'),
    998: mockTransFunc('common:warning.max.998'),
    1000: mockTransFunc('common:warning.max.1000'),
    2000: mockTransFunc('common:warning.max.2000')
  },
  min: {
    1: mockTransFunc('common:warning.min.1'),
    2: mockTransFunc('common:warning.min.2'),
    4: mockTransFunc('common:warning.min.4'),
    6: mockTransFunc('common:warning.min.6'),
    8: mockTransFunc('common:warning.min.8'),
    10: mockTransFunc('common:warning.min.10'),
    20: mockTransFunc('common:warning.min.20')
  },
  zipCodeMax: mockTransFunc('common:warning.zipCode.max'),
  zipCodeMin: mockTransFunc('common:warning.zipCode.min'),
  invalidPhoneNumber: mockTransFunc('common:warning.phone'),
  regexp: mockTransFunc('common:warning.regexp'),
  regexp_required: mockTransFunc('common:warning.regexp_required'),
  required: mockTransFunc('common:warning.required'),
  requiredEmailOrPhone: mockTransFunc('auth:enterEmailOrPhone'),
}

export const ProfileWarning = {
  password: mockTransFunc('profile:validation.password'),
  regexp: mockTransFunc('profile:validation.regexp')
}

export const UserValidation = {
  regexp: mockTransFunc('profile:validation.regexp'),
  password: mockTransFunc('profile:validation.passwordRequirements'),
}

export const BooleanOptions = {
  true: mockTransFunc('common:yes'),
  false: mockTransFunc('common:no')
}

export const DayOptions = {
  today: mockTransFunc('filters:day.today'),
  tomorrow: mockTransFunc('filters:day.tomorrow'),
  yesterday: mockTransFunc('filters:day.yesterday')
}

export const MonthOptions = {
  nextmonth: mockTransFunc('filters:month.next'),
  prevmonth: mockTransFunc('filters:month.prev'),
  thismonth: mockTransFunc('filters:month.this')
}

export const WeekOptions = {
  nextweek: mockTransFunc('filters:week.next'),
  prevweek: mockTransFunc('filters:week.prev'),
  thisweek: mockTransFunc('filters:week.this')
}

export const Filters = {
  teq: mockTransFunc('filters:equal'),
  day: mockTransFunc('filters:day.title'),
  month: mockTransFunc('filters:month.title'),
  tday: mockTransFunc('filters:day.title'),
  week: mockTransFunc('filters:week.title'),
  daysText: mockTransFunc('filters:days'),
  allOptionText: mockTransFunc('common:all'),
  addFilter: mockTransFunc('filters:addFilter'),
  assigned_to: mockTransFunc('filters:assigned_to'),
  assigned_to_group: mockTransFunc('filters:assigned_to_group'),
  beginWith: mockTransFunc('filters:beginWith'),
  between: mockTransFunc('filters:between'),
  close: mockTransFunc('filters:close'),
  contains: mockTransFunc('filters:contains'),
  empty: mockTransFunc('filters:empty'),
  endWith: mockTransFunc('filters:endWith'),
  equal: mockTransFunc('filters:equal'),
  ge: mockTransFunc('filters:ge'),
  gt: mockTransFunc('filters:gt'),
  le: mockTransFunc('filters:le'),
  lt: mockTransFunc('filters:lt'),
  notEqual: mockTransFunc('filters:notEqual'),
  save: mockTransFunc('filters:save'),
  choose_variant: mockTransFunc('filters:choose_variant'),
  type_name: mockTransFunc('filters:type_name'),
  update: mockTransFunc('filters:update'),
  tin: mockTransFunc('filters:tin'),
  and: mockTransFunc('filters:and'),
  filters: mockTransFunc('filters:filters'),
  id: mockTransFunc('filters:id'),
  in: mockTransFunc('filters:in'),
  initiator: mockTransFunc('filters:initiator'),
  isNotNull: mockTransFunc('filters:isNotNull'),
  isNull: mockTransFunc('filters:isNull'),
  location_temp_key: mockTransFunc('filters:location_temp_key'),
  no_filters: mockTransFunc('filters:no_filters'),
  object_type: mockTransFunc('filters:object_type'),
  order_type: mockTransFunc('filters:order_type'),
  request_type: mockTransFunc('filters:request_type'),
  reset: mockTransFunc('filters:reset'),
  result: {
    '%like': mockTransFunc('filters:result.%like'),
    eq: mockTransFunc('filters:result.eq'),
    gt: mockTransFunc('filters:result.gt'),
    in: mockTransFunc('filters:result.in'),
    le: mockTransFunc('filters:result.le'),
    like: mockTransFunc('filters:result.like'),
    'like%': mockTransFunc('filters:result.like%'),
    lt: mockTransFunc('filters:result.lt'),
    ge: mockTransFunc('filters:result.ge'),
    less: mockTransFunc('filters:result.less'),
    after: mockTransFunc('filters:result.after'),
    before: mockTransFunc('filters:result.before'),
    day: mockTransFunc('filters:result.day'),
    month: mockTransFunc('filters:result.month'),
    week: mockTransFunc('filters:result.week')
  },
  handbook_text: {
    empty: mockTransFunc('handbooks:suggest.empty'),
    hint: mockTransFunc('handbooks:suggest.hint'),
    placeholder: mockTransFunc('handbooks:suggest.placeholder')
  },
  show_filters: mockTransFunc('filters:show_filters'),
  show_pending: mockTransFunc('filters:show_pending'),
  submit: mockTransFunc('filters:submit'),
  to: mockTransFunc('filters:to'),
  on: mockTransFunc('common:yes'),
  off: mockTransFunc('common:no'),
  all: mockTransFunc('common:all'),
  radix: mockTransFunc('currency:radix_separator'),
  selectField: mockTransFunc('filters:selectField'),
  thousand: mockTransFunc('currency:thousand_separator'),
  time: mockTransFunc('common:time')
}

export const FiltersName = {
  subject: mockTransFunc('envelopes:table.head.subject'),
  flowState: mockTransFunc('envelopes:table.head.status'),
  flowStarted: mockTransFunc('filters:createdDate'),
  flowCompleted: mockTransFunc('filters:sendDate'),
  flowLastActionDate: mockTransFunc('filters:changeDate'),
  isActionRequired: mockTransFunc('filters:isActionRequired'),
  label: mockTransFunc('filters:label'),
  taskType: mockTransFunc('filters:taskType'),
  recipientName: mockTransFunc('filters:recipientName'),
  recipientEmail: mockTransFunc('filters:recipientEmail'),
  senderName: mockTransFunc('filters:senderName'),
  senderEmail: mockTransFunc('filters:senderEmail'),
}

export const UserCertificatePowerOfAttorneyType = {
  DIGITAL: mockTransFunc('envelopes:signAction.certificate.PoA.type.digital'),
  OTHER: mockTransFunc('envelopes:signAction.certificate.PoA.type.other'),
  PAPER: mockTransFunc('envelopes:signAction.certificate.PoA.type.paper')
}

/** ������� ��� ����� ������������ � ������-����� */
export const BoxRoles = {
  ADMIN: mockTransFunc('boxes:users.roles.admin'),
  MANAGER: mockTransFunc('boxes:users.roles.manager'),
  VIEWER: mockTransFunc('boxes:users.roles.viewer')
}
